import { message } from "antd";
import axios from "axios";
import download from "downloadjs";

// Generate product image
export const generateProductImage =
    (uploaded_image_object, prompt) => async (dispatch) => {
        await axios
            .post(`/api/products/generate_product_image`, {
                uploaded_image: uploaded_image_object,
                prompt: prompt,
            })
            .then(async (response) => {
                dispatch({
                    type: "GENERATE_PRODUCT_IMAGE_SUCCESS",
                    payload: response.data,
                });
            })
            .catch((error) => {
                message.error(error?.response?.data?.message, 5);
            });
    };

// Download product image
export const downloadProductImage =
    (product_uuid, format, resolution, size) => async (dispatch) => {
        await axios
            .get(
                `/api/products/download/${product_uuid}/${format}/${resolution}/${size}`,
                {
                    responseType: "arraybuffer",
                }
            )
            .then(async (response) => {
                await download(
                    response.data,
                    `img.${format}`,
                    `image/${format}`
                );
            })
            .catch((error) => {
                message.error(error?.response?.data?.message, 5);
            });
    };

// Fetch seamless products of a user
export const fetchUserProducts =
    (urlParams, offset, limit) => async (dispatch) => {
        var key = await urlParams.get("key");
        await axios
            .get(`/api/products/user_products/${key}/${offset}/${limit}`)
            .then(async (response) => {
                dispatch({
                    type: "FETCH_USER_PRODUCTS_SUCCESS",
                    payload: response.data,
                    key: "user_products" + "_" + urlParams.toString(),
                });
            })
            .catch((error) => {
                message.error(error?.response?.data?.message, 5);
            });
    };
